import React, { useState, useEffect } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import AddRestaurantSauces from "./AddRestaurantSauce"; // Import the AddSauces component
import AddRestaurantDrinks from "./AddRestaurantDrinks"; // Import the AddSauces component
const API_URL = process.env.REACT_APP_API_URL;


const AddCustomItemForm = () => {
  const [categories, setCategories] = useState({});
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const [itemImg, setItemImg] = useState("");
  const [description, setDescription] = useState("");
  const [ownerId, setOwnerId] = useState("");
  const [formData, setFormData] = useState({
    isSizeAvailable: false,
    sizes: [],
  });
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("ownerToken");
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        setOwnerId(decodedToken.id);
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        if (ownerId) {
          const response = await axios.get(
            `${API_URL}/api/cloneCategory/${ownerId}`
          );
          setCategories(response.data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, [ownerId]);

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
    setSelectedItem("");
    setItemImg("");
  };

  const handleItemChange = (e) => {
    const itemName = e.target.value;
    setSelectedItem(itemName);

    if (selectedCategory) {
      const selectedItemData = categories[selectedCategory]?.find(
        (item) => item.itemName === itemName
      );
      setItemImg(selectedItemData?.itemImg || "");
    }
  };

  const handleUploadImage = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("itemImg", file);

    try {
      const response = await axios.post(
        `${API_URL}/api/uploadImage`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      setItemImg(response.data.imageUrl);
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const itemData = {
      ownerId,
      category: selectedCategory,
      items: [
        {
          itemName: selectedItem,
          description,
          itemImg,
          isSizeAvailable: formData.isSizeAvailable,
          sizes: formData.isSizeAvailable ? formData.sizes : [],
        },
      ],
    };
    console.log("itemData", itemData);
    try {
      const token = localStorage.getItem("ownerToken");
      if (!token) {
        alert("Please log in to add an item.");
        return;
      }

      await axios.post(
        `${API_URL}/api/addRestMenu`,
        itemData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      alert("Item added successfully!");
      window.location.reload();
      resetForm();
    } catch (error) {
      console.error("Error adding item:", error);
      alert("Failed to add item. Please try again.");
    }
  };

  const handleOrderDetailsClick = () => {
    navigate("/ownerorders");
  };

  const resetForm = () => {
    setSelectedCategory("");
    setSelectedItem("");
    setItemImg("");
    setDescription("");
    setFormData({ isSizeAvailable: false, sizes: [] });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, isSizeAvailable: e.target.checked });
  };

  const handleSizeChange = (index, field, value) => {
    const newSizes = [...formData.sizes];
    newSizes[index][field] = value;
    setFormData({ ...formData, sizes: newSizes });
  };

  const addSize = () => {
    setFormData({
      ...formData,
      sizes: [...formData.sizes, { size: "", basePrice: "", menuPrice: "" }],
    });
  };

  const removeSize = (index) => {
    const newSizes = formData.sizes.filter((_, i) => i !== index);
    setFormData({ ...formData, sizes: newSizes });
  };

  return (
    <div>
      <h2>Add Custom Item</h2>
      <button onClick={handleOrderDetailsClick}>Order Details</button>
      <form onSubmit={handleSubmit}>
        <label>Category</label>
        <select value={selectedCategory} onChange={handleCategoryChange} required>
          <option value="">Select Category</option>
          {Object.keys(categories).map((categoryName) => (
            <option key={categoryName} value={categoryName}>
              {categoryName}
            </option>
          ))}
        </select>

        <label>Item Name</label>
        <select value={selectedItem} onChange={handleItemChange} disabled={!selectedCategory}>
          <option value="">Select Item</option>
          {selectedCategory &&
            categories[selectedCategory]?.map((item) => (
              <option key={item._id} value={item.itemName}>
                {item.itemName}
              </option>
            ))}
        </select>

        <label>Description</label>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Enter item description"
        />

        <label>Item Image</label>
        <input type="file" onChange={handleUploadImage} />

        <label>
          <input
            type="checkbox"
            name="isSizeAvailable"
            checked={formData.isSizeAvailable}
            onChange={handleChange}
          />
          Has Sizes?
        </label>

        {formData.isSizeAvailable && (
          <div>
            <h3>Sizes and Prices</h3>
            {formData.sizes.map((size, index) => (
              <div key={index} className="size-group">
                <input
                  type="text"
                  placeholder="Size"
                  value={size.size}
                  onChange={(e) => handleSizeChange(index, 'size', e.target.value)}
                />
                <input
                  type="number"
                  placeholder="Base Price"
                  value={size.basePrice}
                  onChange={(e) => handleSizeChange(index, 'basePrice', e.target.value)}
                />
                <input
                  type="number"
                  placeholder="Menu Price"
                  value={size.menuPrice}
                  onChange={(e) => handleSizeChange(index, 'menuPrice', e.target.value)}
                />
                <button type="button" onClick={() => removeSize(index)}>Remove</button>
              </div>
            ))}
            <button type="button" onClick={addSize}>Add Size</button>
          </div>
        )}

        <button type="submit">Add Item</button>
      </form>

      {/* Add the sauce selection */}
      <AddRestaurantSauces ownerId={ownerId} />
      <AddRestaurantDrinks ownerId={ownerId} />
    </div>
  );
};

export default AddCustomItemForm;
